import flow1Data from './flow1';
import flow2Data from './flow2';
import flow3Data from './flow3';
import flow4Data from './flow4';

const data = {
  workflow1: flow1Data,
  workflow2: flow2Data,
  workflow3: flow3Data,
  workflow4: flow4Data
};

const getFlowData = (flowId) => {
  const workflow = `workflow${flowId}`;

  return data[workflow];
};

export default getFlowData;



// WEBPACK FOOTER //
// ./src/screens/data/data.js